// Croqui: `components/Pill.tsx`.
//
// WEB-133: é o `Badge` de `components/ui` com `dot`: pílula NEUTRA e um quadrado pequeno de
// cor dizendo o estado. O texto nunca ganha cor. Mesmo selo das telas do lojista.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import { Badge } from '../ui/badge.tsx';
import type { Tone } from './ink.ts';

const VARIANT = {
  ok: 'success',
  wait: 'warning',
  bad: 'destructive',
  neutral: 'secondary',
  info: 'secondary',
} as const satisfies Record<Tone, string>;

/** Status: pílula neutra com o quadrado de cor do tom. */
export function Pill({
  tone,
  children,
  className,
}: {
  tone: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Badge
      variant={VARIANT[tone]}
      dot
      // `info` é o tom "em tinta": quadrado na cor do texto, não no cinza do neutro.
      className={cn(tone === 'info' && '[--dot:var(--foreground)]', className)}
    >
      {children}
    </Badge>
  );
}

export type { Tone as PillTone };
